(function(){
	angular.module('cvsApp').directive('storeLocator',function(){
		return{
			restrict:'E',
			templateUrl: '../storelocator/app/components/storelocator/storeLocator.html',
			controller: function($scope,cvsAppData, $rootScope){
				$scope.SL = this;
				$scope.SL.reviewStore = cvsAppData.getReviewOrder();
				var params = new URLSearchParams(window.location.search)
				for (var param of params) {
			   if (params.has('choosePharmacy')){
					$rootScope.isNative ='true';
				   }
				 }
				$scope.SL.close = function(elementId){
					$scope.SL.setFocus(elementId)
                    if($rootScope.showStoreDetailsView){
                        $rootScope.showStoreDetailsView = false;
                        return;
					}
					if($scope.SL.reviewStore){
						$rootScope.closeInfopinOnClose();
						parent.postMessage($scope.SL.reviewStore, "*"); 
					}
					$scope.$close();
					$scope.SL.setFocus(elementId)
                    if(cvsUtility.setNativeCheck()){
                        try{
                            native.enableHeader();
                        }catch(ex){}			
                    }
                }
				$scope.SL.setFocus = function(a){
					 setTimeout(function(){					
					 document.getElementById(a).focus();					
					//  document.getElementById(a).classList.add('foc111');				
					 }, 10);					
					 }

			}
		}
		
	})
})();